export function noteClassification(value = {}, defaults = {}) {
  value = value || {};
  const scope = value.scope || value.sourceScope || defaults.scope || 'general';
  const assigneeUids = [...new Set((Array.isArray(value.assigneeUids) ? value.assigneeUids : value.assigneeUid ? [value.assigneeUid] : []).filter(Boolean))];
  const assignees = Array.isArray(value.assignees) ? value.assignees.filter(Boolean) : value.assignee ? [value.assignee] : [];
  return {
    scope: scope === 'map' ? 'map' : 'general',
    mapId: scope === 'map' ? value.mapId || value.sourceMapId || defaults.mapId || null : null,
    mapName: scope === 'map' ? value.mapName || defaults.mapName || '' : '',
    assigneeUids,
    assignees,
    assigneeUid: assigneeUids[0] || null,
    assignee: assignees[0] || null,
    side: ['DEF', 'ATK', 'ATK & DEF'].includes(value.side) ? value.side : 'ATK & DEF',
  };
}
export function classificationLabel(value, defaults) {
  const c = noteClassification(value, defaults);
  return `${c.scope === 'map' ? `Map Specific · ${c.mapName || c.mapId || 'Map'}` : 'General'} · ${c.assignees.join(', ') || (c.assigneeUids.length ? 'Assigned members' : 'Team')} · ${c.side}`;
}
